// React hooks
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';



// ===========
// ScrollToTop – simple helper Component that ensures all newly-opened pages start from the top. Used in App.js
// ===========
function ScrollToTop() {
    
    // get pathname
    const { pathname } = useLocation();

    // re-run effect whenever pathname changes
    useEffect( () => {
        
        // reset window to top-left corner
        window.scrollTo(0,0);
    }, [pathname]);

    // this Component renders nothing
    return null;
};


// Export statement
export default ScrollToTop;